module.exports = __webpack_public_path__ + "fonts/icomoon_rrss.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/icomoon_rrss/icomoon_rrss.svg
// module id = sehS
// module chunks = 1